module.exports = __webpack_public_path__ + "first-100-glossy_number.jpg?b7a5c11fe3b9792377a1a27dfe165ea4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-100-glossy_number.jpg
// module id = 414
// module chunks = 0